import { render, staticRenderFns } from "./EditOrderItemLocationToggle.vue?vue&type=template&id=5d668df5&scoped=true"
import script from "./EditOrderItemLocationToggle.vue?vue&type=script&lang=js"
export * from "./EditOrderItemLocationToggle.vue?vue&type=script&lang=js"
import style0 from "./EditOrderItemLocationToggle.vue?vue&type=style&index=0&id=5d668df5&prod&lang=scss&scoped=true"
import style1 from "./EditOrderItemLocationToggle.vue?vue&type=style&index=1&id=5d668df5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d668df5",
  null
  
)

export default component.exports